import { Button, Col, Form, Input, Row, Space } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useRef } from 'react';
import { YouTubeVideoForm } from 'src/lib/form-interfaces';
import SelectTags from '../select-tags';

const { TextArea } = Input;

interface Props {
	youtubeVideoId?: string;
	youtubeVideoTitle?: string;
	youtubeVideoDescription?: string;
	youtubeVideoDuration?: string;
	youtubeVideoWeight?: number;
	youtubeVideoTags?: string[];
	canDelete?: boolean;
	onDelete?: React.MouseEventHandler<HTMLElement>;
	onSave: (data: YouTubeVideoForm) => void;
}

const YouTubeVideoCard = (props: Props) => {
	const [form] = useForm<YouTubeVideoForm>();
	const selectedHTags = useRef<string[]>([]);

	const createYouTubeVideo = (data: YouTubeVideoForm) => {
		props.onSave({
			...data,
			tags: selectedHTags.current,
		});
	};

	return (
		<Form
			form={form}
			onFinish={createYouTubeVideo}
			style={{
				width: '100%',
			}}
		>
			<Row style={{ width: '100%' }} gutter={16}>
				<Col span={24} lg={12}>
					<label className="input-fields-label">YouTube Video ID</label>
					<Form.Item
						rules={[{ required: true, message: 'Please enter YouTube Video ID' }]}
						name="videoId"
						hasFeedback
						initialValue={props.youtubeVideoId}
					>
						<Input
							type="text"
							placeholder="E.g: dQw4w9WgXcQ"
							className="input-fields"
						/>
					</Form.Item>
					<p style={{ marginTop: '-10px', fontSize: '12px', opacity: 0.6 }}>
						The video ID can be found in the YouTube URL after &#39;v=&#39;. Example:
						https://www.youtube.com/watch?v=<strong>dQw4w9WgXcQ</strong>
					</p>
				</Col>

				<Col span={24} lg={12}>
					<label className="input-fields-label">Video Title</label>
					<Form.Item
						rules={[{ required: true, message: 'Please enter video title' }]}
						name="title"
						hasFeedback
						initialValue={props.youtubeVideoTitle}
					>
						<Input
							type="text"
							placeholder="Amazing Dubai Nightlife 2024"
							className="input-fields"
						/>
					</Form.Item>
				</Col>

				<Col span={24}>
					<label className="input-fields-label">Description (Optional)</label>
					<Form.Item
						name="description"
						hasFeedback
						initialValue={props.youtubeVideoDescription}
					>
						<TextArea
							rows={3}
							placeholder="Brief description of the video..."
							className="input-fields"
						/>
					</Form.Item>
				</Col>

				<Col span={24} lg={8}>
					<label className="input-fields-label">Duration</label>
					<Form.Item
						rules={[{ required: true, message: 'Please enter duration' }]}
						name="duration"
						hasFeedback
						initialValue={props.youtubeVideoDuration}
					>
						<Input
							type="text"
							placeholder="E.g: 5:23"
							className="input-fields"
						/>
					</Form.Item>
				</Col>

				<Col span={24} lg={8}>
					<label className="input-fields-label">Position</label>
					<Form.Item
						name="weight"
						hasFeedback
						initialValue={props.youtubeVideoWeight}
						rules={[
							{
								validator: (rule, value: string, back) => {
									if (value !== undefined) {
										if (value.length > 4) {
											back('Too large');
											return;
										}
										if (value !== '' && parseInt(value) < 1) {
											back('Minimum value is 1');
											return;
										}
									}
									back(undefined);
									return;
								},
							},
						]}
					>
						<Input
							type="number"
							min={1}
							placeholder="Position / Sequence No."
							className="input-fields"
						/>
					</Form.Item>
				</Col>

				<Col
					span={24}
					lg={8}
					style={{
						position: 'relative',
					}}
				>
					<label className="input-fields-label">Page Tags (Optional)</label>

					<SelectTags
						placeholder="Select Tags"
						initialValues={props.youtubeVideoTags || []}
						onSelectionChange={(tags) => {
							selectedHTags.current = tags;
						}}
						onInit={(tags) => (selectedHTags.current = tags)}
					/>
				</Col>

				<Col span={24}>
					<hr style={{ opacity: '0.25' }} />

					<Row justify={'end'}>
						<Space size="small">
							<Button className="btn-main save" htmlType={'submit'}>
								Save
							</Button>

							{!props.canDelete ? (
								<Button
									className="btn-main"
									onClick={() => {
										window.history.back();
									}}
								>
									Cancel
								</Button>
							) : (
								<Button className="btn-main delete" onClick={props.onDelete}>
									Delete
								</Button>
							)}
						</Space>
					</Row>
				</Col>
			</Row>
		</Form>
	);
};

export default YouTubeVideoCard;
